export default {"src":"/_next/static/media/auto-debit.2118dc85.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};